module.exports = __webpack_public_path__ + "static/bottle-bf6a34d838248331a87d599653209638.jpg";